import GridOptions from './GridOptions';
import MuiGrid from '../../../../UI/MuiGrid/MuiGrid';

import { useTranslation } from 'react-i18next';
import { icons } from '../../../../../../shared/icons';
import {
  formatDateFromDB,
  formatDateTimeGrid,
} from '../../../../../../utils/FormatDate';

// evidencijaSlanja: kolona „Poslato na“ (napomena) i vreme slanja umesto datuma
const GridProvider = ({
  data,
  loading,
  handleOpenFile,
  handleOpenDeleteDialog,
  downloadFile,
  editFile,
  evidencijaSlanja = false,
}) => {
  const { t, i18n } = useTranslation();
  const columns = [
    {
      field: 'id',
      disableExport: true,
      headerName: '',
      width: 100,
      sortable: false,
      filterable: false,
      renderCell: (e) => (
        <GridOptions
          openFile={() => handleOpenFile(e.row)}
          handleOpenDeleteDialog={() => handleOpenDeleteDialog(e.id)}
          downloadFile={() => downloadFile(e.row.path, e.row.name)}
          editFile={() => editFile(e.row)}
        >
          <button className="header-options">{icons.MENU_ICON}</button>
        </GridOptions>
      ),
    },
    {
      field: 'nazivFajla',
      headerName: t('fileName'),
      width: 350,
    },
    ...(evidencijaSlanja
      ? [
          {
            field: 'poslatoNa',
            headerName: t('pdfDialog.poslatoNa'),
            width: 400,
            sortable: false,
            valueGetter: (item) => (item.row.poslatoNa || []).join(', '),
            renderCell: (item) => {
              const poslato = item.row.poslatoNa || [];
              const nijePoslato = item.row.nijePoslatoNa || [];
              if (!poslato.length && !nijePoslato.length) return <span>—</span>;
              return (
                <span style={{ whiteSpace: 'normal', lineHeight: 1.3 }}>
                  {poslato.join(', ')}
                  {nijePoslato.length > 0 && (
                    <span style={{ color: '#d32f2f', display: 'block' }}>
                      {t('pdfDialog.nijePoslatoNa')}: {nijePoslato.join(', ')}
                    </span>
                  )}
                </span>
              );
            },
          },
        ]
      : []),

    {
      field: 'datumDokumenta',
      headerName: evidencijaSlanja ? t('pdfDialog.vremeSlanja') : t('date'),
      width: 200,
      renderCell: (item) => {
        if (!item.row.datumDokumenta) return <span />;
        return (
          <span>
            {evidencijaSlanja
              ? formatDateTimeGrid(item.row.datumDokumenta)
              : formatDateFromDB(item.row.datumDokumenta)}
          </span>
        );
      },
    },

    {
      field: 'size',
      headerName: t('fileSize'),
      width: 150,
      renderCell: (item) => {
        return <span>{(item.row.size / 1024 ** 2).toFixed(2)} MB</span>;
      },
    },
  ];
  return (
    <div
      style={{
        marginTop: '10px',
        height: '60vh',
        width: '99%',
      }}
    >
      <MuiGrid data={data} loading={loading} columns={columns} />
    </div>
  );
};

export default GridProvider;
